import { styled, useMediaQuery } from '@mui/material';

export const CenterContainer = styled('div')<{
	isPlP?: boolean;
	mobileNoPaddingRight?: boolean;
}>(({ theme, isPlP, mobileNoPaddingRight }) => {
	const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

	let width = '90vw';
	let paddingLeft = '0';

	if (isMobile) {
		if (mobileNoPaddingRight) {
			width = '100vw';
			paddingLeft = '20px';
		} else {
			width = 'calc(100vw - 40px)';
		}
	} else if (isPlP) {
		width = '95vw';
	}

	return {
		maxWidth: `${isPlP ? theme.breakpoints.values.lg * 2 : theme.breakpoints.values.lg}px`,
		width,
		paddingLeft,
	};
});
